module.exports = __webpack_public_path__ + "img/stock4.7b94705f.png";